<div class="m-3">
  <app-page-title [feature]="tenantFeatures.TimeLogs"></app-page-title>
  <div class="mt-4">
    <app-timelogs-grid></app-timelogs-grid>
  </div>
</div>
